import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILocation } from '../typing/location.interface';

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(private http: HttpClient) {
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<ILocation>> {
        return this.http.get<IPaginatedResponse<ILocation>>(`${environment.API_BASE_PATH}/locations`, {params: query});
    }

    getLocation(locationId: number): Observable<ILocation> {
        return this.http.get<ILocation>(`${environment.API_BASE_PATH}/location/${locationId}`);
    }

    createLocation(location: ILocation): Observable<ILocation> {
        return this.http.post<ILocation>(`${environment.API_BASE_PATH}/location`, location);
    }

    updateLocation(id: number, location: ILocation): Observable<ILocation> {
        return this.http.put<ILocation>(`${environment.API_BASE_PATH}/location/${id}`, location);
    }
}
